import { VendorActionTypes } from './constants';
import { IVendor } from 'pages/apps/Vendors/types';

/**
 * State type
 */
type State = {
    results: IVendor[];
    totalRecords: number;
    loading: boolean;
    error?: string;
    vendorDetailsById: IVendor | null;
    isVendorCreated: boolean;
    isVendorUpdated: boolean;
};

/**
 * Initial state
 */
const INIT_STATE: State = {
    results: [],
    totalRecords: 0,
    loading: false,
    vendorDetailsById: null,
    isVendorCreated: false,
    isVendorUpdated: false,
};

/**
 * Action type
 */
type VendorActionType = {
    type:
        | VendorActionTypes.API_RESPONSE_SUCCESS
        | VendorActionTypes.API_RESPONSE_ERROR
        | VendorActionTypes.GET_VENDORS
        | VendorActionTypes.GET_VENDOR_BY_ID
        | VendorActionTypes.ADD_VENDOR
        | VendorActionTypes.UPDATE_VENDOR
        | VendorActionTypes.DELETE_VENDOR
        | VendorActionTypes.RESET;
    payload: {
        actionType?: string;
        data?: any;
        error?: string;
    };
};

/**
 * Reducer
 */
const Vendors = (
    state: State = INIT_STATE,
    action: VendorActionType
): State => {
    switch (action.type) {
        case VendorActionTypes.API_RESPONSE_SUCCESS: {
            const { actionType, data } = action.payload;

            switch (actionType) {
                case VendorActionTypes.GET_VENDORS: {
                    const vendorData = data?.data || data;

                    return {
                        ...state,
                        results:
                            vendorData?.results ||
                            vendorData?.vendors ||
                            vendorData ||
                            [],
                        totalRecords:
                            vendorData?.totalResults ||
                            vendorData?.totalRecords ||
                            vendorData?.count ||
                            0,
                        loading: false,
                        error: undefined,
                        isVendorCreated: false,
                        isVendorUpdated: false,
                    };
                }

                case VendorActionTypes.GET_VENDOR_BY_ID:
                    return {
                        ...state,
                        vendorDetailsById: data?.data || data || null,
                        loading: false,
                        error: undefined,
                    };

                case VendorActionTypes.ADD_VENDOR:
                    return {
                        ...state,
                        results: [
                            data?.data || data,
                            ...state.results,
                        ],
                        vendorDetailsById: data?.data || data || null,
                        isVendorCreated: true,
                        loading: false,
                        error: undefined,
                    };

                case VendorActionTypes.UPDATE_VENDOR:
                    return {
                        ...state,
                        vendorDetailsById: data?.data || data || null,
                        isVendorUpdated: true,
                        loading: false,
                        error: undefined,
                    };

                case VendorActionTypes.DELETE_VENDOR:
                    return {
                        ...state,
                        results: state.results.filter(
                            (vendor) =>
                                vendor.id !==
                                (data?.data?.id ?? data?.id)
                        ),
                        loading: false,
                        error: undefined,
                    };

                default:
                    return state;
            }
        }

        case VendorActionTypes.API_RESPONSE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };

        case VendorActionTypes.GET_VENDORS:
            return {
                ...state,
                loading: true,
                isVendorCreated: false,
                isVendorUpdated: false,
            };

        case VendorActionTypes.ADD_VENDOR:
        case VendorActionTypes.GET_VENDOR_BY_ID:
        case VendorActionTypes.UPDATE_VENDOR:
        case VendorActionTypes.DELETE_VENDOR:
            return {
                ...state,
                loading: true,
            };

        case VendorActionTypes.RESET:
            return {
                ...INIT_STATE,
            };

        default:
            return state;
    }
};

export default Vendors;